import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import RangeSlider from '../../../../../../../../components/global/RangeSlider';
import Badge from '../../../../../../../../components/global/Badge';

const propTypes = {
  visible: PropTypes.bool.isRequired,
  defaultDuration: PropTypes.number.isRequired,
  onDefaultDurationChange: PropTypes.func.isRequired,
};

const SecondarySlideDurationView = ({
  visible,
  defaultDuration,
  onDefaultDurationChange,
}) => {
  const currentDefaultDurationTimeout = useRef();
  const [currentDefaultDuration, setCurrentDefaultDuration] = useState(
    defaultDuration,
  );

  useEffect(() => {
    setCurrentDefaultDuration(defaultDuration);
  }, [defaultDuration]);

  useEffect(() => {
    if (currentDefaultDuration !== defaultDuration) {
      if (currentDefaultDurationTimeout.current) {
        clearTimeout(currentDefaultDurationTimeout.current);
      }
      currentDefaultDurationTimeout.current = setTimeout(
        () => onDefaultDurationChange(currentDefaultDuration),
        500,
      );
    }

    return () => {
      if (currentDefaultDurationTimeout.current) {
        clearTimeout(currentDefaultDurationTimeout.current);
      }
    };
  }, [currentDefaultDuration]);

  if (!visible) {
    return null;
  }

  return (
    <div className="w-100">
      <p className="text-sm text-muted text-uppercase text-extra-bold">
        Delay between slides
      </p>
      <div className="w-100 d-flex align-items-center text-sm text-nowrap">
        <RangeSlider
          className="mr-2"
          onChange={values => setCurrentDefaultDuration(1000 * values[0])}
          values={[currentDefaultDuration / 1000]}
          min={0}
          max={10}
        />
        <span className="text-light">
          <Badge
            badgeSize="xs"
            badgeStyle="secondary"
            className="mr-1 text-bold"
          >
            {currentDefaultDuration / 1000}{' '}
          </Badge>
          {currentDefaultDuration === 1000 ? 'sec' : 'secs'}
        </span>
      </div>
    </div>
  );
};

SecondarySlideDurationView.propTypes = propTypes;

export default SecondarySlideDurationView;
